<template>
  <div class="website-page">
    <Tabs value="student">
      <TabPane label="学员用户" name="student">
        <record data-url="/api/userLoginLog/1"></record>
      </TabPane>
      <TabPane label="讲师用户" name="teacher">
        <record data-url="/api/userLoginLog/2"></record>
      </TabPane>
      <TabPane label="管理员用户" name="admin">
        <record data-url="/api/userLoginLog/3" comType="admin"></record>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import record from "./Record";
export default {
  name: "WebSite",
  components: {
    record
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
